var map = {
	"./BTC.svg": 3090,
	"./ETH.svg": 5694,
	"./LTC.svg": 230,
	"./PAX non mono.svg": 2811,
	"./PAXG.svg": 6105,
	"./UNI.svg": 7493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7604;